var map = {
	"./no_preview.png": 54,
	"./typeL_high.png": 93,
	"./typeL_high_lamp.png": 94,
	"./typeL_low.png": 95,
	"./typeL_low_lamp.png": 96,
	"./typeP_high.png": 97,
	"./typeP_high_lamp.png": 98,
	"./typeP_low.png": 53,
	"./typeP_low_lamp.png": 99,
	"./typeS_high.png": 100,
	"./typeS_high_lamp.png": 101,
	"./typeS_low.png": 102,
	"./typeS_low_lamp.png": 103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;